import { render } from "./profile-modal.vue?vue&type=template&id=32007015"
import script from "./profile-modal.vue?vue&type=script&lang=js"
export * from "./profile-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__